import generateTypes from '../../utils/generateTypes';

export const GET_EVENT_HUBS = generateTypes('GET_EVENT_HUBS');
export const RESET_EVENT_HUBS = generateTypes('RESET_EVENT_HUBS');
